<div class="e-search-filter-summary-modal">

    <button class="e-close-button" aria-label="Close search and filter summary" (click)="closeSearchAndFilterSummary()">
        <i class="fa-solid fa-xmark"></i>
    </button>

    <h1>Search and Filter Summary</h1>

    <p class="e-modal-description">
        A summary of your search and filter selections, including the selections you have chosen to focus on and those you
        have chosen to remove from your results.
    </p>

    <h2>Initial search term:</h2>
    <p class="e-initial-search-term">"{{ searchTerm }}" <i>in</i> {{ searchOption.label }}</p>

    <h2>Filter selections:</h2>

    <mat-tab-group animationDuration="0ms" class="e-skewed-tabs" role="tabpanel">

        <mat-tab label="Countries">
            <div class="e-tab-content" *ngIf="filters.countries.length > 0">
                <div class="e-column" *ngFor="let column of getColumns(filters.countries)">
                    <ul class="e-filter-list">
                        <li *ngFor="let item of column">{{ item.name }}</li>
                    </ul>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Categories">
            <div class="e-tab-content" *ngIf="filters.categories.length > 0">
                <ul class="e-category-filter-list">
                    <li *ngFor="let item of filters.categories">
                        <h4>{{ item.name }}</h4>
                        <ng-template *ngTemplateOutlet="childCategoriesTemplate; context: { $implicit: item }"></ng-template>
            
                        <ng-template #childCategoriesTemplate let-item>
                            <ul *ngIf="item.childCategories">
                                <li *ngFor="let child of item.childCategories">
                                    <p>
                                        {{ child.name }}<br />
                                        <span class="e-category-breadcrumb">{{ child.breadcrumb }} /</span>
                                    </p>
                                    <ng-container *ngTemplateOutlet="childCategoriesTemplate; context: { $implicit: child }"></ng-container>
                                </li>
                            </ul>
                        </ng-template>
                    </li>
                </ul>
            </div>
        </mat-tab>

        <mat-tab label="Suppliers">
            <div class="e-tab-content" *ngIf="filters.suppliers.length > 0">
                <div class="e-column" *ngFor="let column of getColumns(filters.suppliers)">
                    <ul class="e-filter-list">
                        <li *ngFor="let item of column">{{ item.name }}</li>
                    </ul>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Brands">
            <div class="e-tab-content" *ngIf="filters.brands.length > 0">
                <div class="e-column" *ngFor="let column of getColumns(filters.brands)">
                    <ul class="e-brand-filter-list">
                        <li *ngFor="let item of column">
                            {{ item.brandName }}
                            <ul *ngIf="item.subBrands && item.subBrands.length > 0">
                                <li *ngFor="let subItem of item.subBrands">{{ subItem.subBrandName }}</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Attribute Types">
            <div class="e-tab-content" *ngIf="filters.attributeTypes.length > 0">
                <div class="e-column" *ngFor="let column of getColumns(filters.attributeTypes)">
                    <ul class="e-filter-list">
                        <li *ngFor="let item of column">{{ item.name }}</li>
                    </ul>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Attributes">
            <div class="e-tab-content" *ngIf="filters.attributes.length > 0">
                <div class="e-column" *ngFor="let column of getColumns(filters.attributes)">
                    <ul class="e-filter-list">
                        <li *ngFor="let item of column">{{ item.value }}</li>
                    </ul>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Retailer Types">
            <div class="e-tab-content" *ngIf="filters.retailerTypes.length > 0">
                <div class="e-column" *ngFor="let column of getColumns(filters.retailerTypes)">
                    <ul class="e-filter-list">
                        <li *ngFor="let item of column">{{ item.name }}</li>
                    </ul>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Retailers">
            <div class="e-tab-content" *ngIf="filters.retailers.length > 0">
                <div class="e-column" *ngFor="let column of getColumns(filters.retailers)">
                    <ul class="e-filter-list">
                        <li *ngFor="let item of column">{{ item.name }}</li>
                    </ul>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Date / Price / SKU Size">
            <div class="e-tab-content e-date-price-sku-size-tab">
                <div *ngIf="filters?.dateRange?.startDate && filters?.dateRange?.endDate">
                    <dl class="e-dates-frequency">
                        <dt>Date range:</dt>
                        <dd>
                            {{ filters.dateRange?.startDate | date: 'mediumDate' }} -
                            {{ filters.dateRange?.endDate | date: 'mediumDate' }}
                        </dd>
                    </dl>
                </div>
                <div *ngIf="filters?.firstSeenPriceRange || filters?.lastSeenPriceRange">
                    <dl class="e-price-filters">
                        <ng-container *ngIf="filters?.firstSeenPriceRange">
                            <dt>First seen price:</dt>
                            <dd>{{ filters.firstSeenPriceRange?.min }} - {{ filters.firstSeenPriceRange?.max }}</dd>
                        </ng-container>
                        <ng-container *ngIf="filters?.lastSeenPriceRange">
                            <dt>Last seen price:</dt>
                            <dd>{{ filters.lastSeenPriceRange?.min }} - {{ filters.lastSeenPriceRange?.max }}</dd>
                        </ng-container>
                    </dl>
                </div>
                <div *ngIf="filters?.volumeRange || filters?.weightRange || filters?.countRange">
                    <dl class="e-total-sku-size-filters">
                        <dt>Total SKU size:</dt>
                        <dd>
                            <div *ngIf="filters?.volumeRange">
                                Volume - {{ filters.volumeRange?.measureOptions }}<br />
                                {{ filters.volumeRange?.min }} - {{ filters.volumeRange?.max }}
                            </div>
                            <div *ngIf="filters?.weightRange">
                                Weight - {{ filters.weightRange?.measureOptions }}<br />
                                {{ filters.weightRange?.min }} - {{ filters.weightRange?.max }}
                            </div>
                            <div *ngIf="filters?.countRange">
                                Count<br />
                                {{ filters.countRange?.min }} - {{ filters.countRange?.max }}
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </mat-tab>

        <!-- <mat-tab label="Promotions"></mat-tab> -->
    </mat-tab-group>

</div>
